import type { AnyAction } from 'redux';
import { FETCH_LINK_CREATION_BLOCKED_STATUS } from '../actions/FraudFighterActions';
import { reducerWrapper } from '../support/utils';

type FraudFighterReducerLoading = {
  loading: true;
  isLinkCreationBlocked: null;
};

type FraudFighterReducerLoaded = {
  loading: false;
  isLinkCreationBlocked: boolean;
};

export type FraudFighterReducer = FraudFighterReducerLoading | FraudFighterReducerLoaded;

export const INIT_STATE: FraudFighterReducer = {
  loading: true,
  isLinkCreationBlocked: null,
};

const Handler = (state: FraudFighterReducer, action: AnyAction): FraudFighterReducer => {
  switch (action.type) {
    case FETCH_LINK_CREATION_BLOCKED_STATUS.response:
      return {
        ...state,
        isLinkCreationBlocked: action.data.is_link_creation_blocked,
        loading: false,
      };

    case FETCH_LINK_CREATION_BLOCKED_STATUS.request:
      return {
        ...state,
        isLinkCreationBlocked: null,
        loading: true,
      };

    default:
      return state;
  }
};

const FraudFighter = reducerWrapper<FraudFighterReducer, AnyAction>(INIT_STATE, Handler, {
  request: [],
  error: [],
});

export default FraudFighter;
